<template>
  <div>
    <h1>Módulos</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoModulo" style="z-index: 1000;" />

    <SGPFormSelectComponent
      :name="'exibirItensDeletados'"
      :listaDeOptions="opcoesSelect"
      v-model="exibirItensDeletados"
      :optionLabel="'nome'"
      :placeholder="'Visualizar Itens Deletados'"
      :error="validationErrors.first('exibirItensDeletados')"
      data-vv-as="Visualizar Itens Deletados"
      :optionSelecione="'Não'"
      @change="filtrarModulosDeletados($event)"
    />

    <template v-if="listaDeModulos.length">
      <SGPPaginacaoComponent
        v-if="paginacao"
        :paginacao="paginacao"
        @sgpAtualizarPaginacao="realizarPaginacao"
        :key="paginacao.current_page"
      >
        <SGPTabelaComponent
          :colunas="colunas"
          :dados="listagemModulos"
          @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
          @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
          @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
          @sgpTabelaRestaurarSelecionadoEmit="restaurarModuloSelecionado"
        >
          <template v-slot:item.redirecionarUsuarios="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              color="warning"
              :to="item.redirecionarUsuarios"
              x-small
              :disabled="item.deleted_at"
            >
              <v-icon color="white" small>mdi-account-multiple</v-icon>
            </SGPFormBotaoComponent>
          </template>

          <template v-slot:item.redirecionarMenus="{ item }">
            <SGPFormBotaoComponent
              fab
              rounded
              target="_blank"
              color="info"
              :to="item.redirecionarMenus"
              x-small
              :disabled="item.deleted_at"
            >
              <v-icon color="white" small>mdi-menu-open</v-icon>
            </SGPFormBotaoComponent>
          </template>
        </SGPTabelaComponent>
      </SGPPaginacaoComponent>

      <SGPTabelaComponent
        v-else
        :colunas="colunas"
        :dados="listagemModulos"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
        @sgpTabelaRestaurarSelecionadoEmit="restaurarModuloSelecionado"
      >
        <template v-slot:item.redirecionarUsuarios="{ item }">
          <SGPFormBotaoComponent
            fab
            rounded
            color="warning"
            :to="item.redirecionarUsuarios"
            x-small
            :disabled="item.deleted_at"
          >
            <v-icon color="white" small>mdi-account-multiple</v-icon>
          </SGPFormBotaoComponent>
        </template>

        <template v-slot:item.redirecionarMenus="{ item }">
          <SGPFormBotaoComponent
            fab
            rounded
            target="_blank"
            color="info"
            :to="item.redirecionarMenus"
            x-small
            :disabled="item.deleted_at"
          >
            <v-icon color="white" small>mdi-menu-open</v-icon>
          </SGPFormBotaoComponent>
        </template>
      </SGPTabelaComponent>
    </template>

    <SGPAlertaComponent v-else />

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Módulo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioModuloComponent :tipoFormulario="tipoFormulario" :modulo="modulo" />
    </SGPModalComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />

    <SGPLoadingComponent v-if="loadingModulo" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioModuloComponent from '../components/FormularioModuloComponent.vue'
import deletar from '@/common/mixins/deletar.js'

export default {
  name: 'CtrlModulosPage',
  components: { FormularioModuloComponent },
  mixins: [deletar],

  data() {
    return {
      modulosSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      modulo: {},
      exibirItensDeletados: false,
      opcoesSelect: [
        { id: true, nome: 'Sim' },
        { id: false, nome: 'Não' }
      ]
    }
  },

  created() {
    this.listarModulosAdmin({ exibirItensDeletados: this.exibirItensDeletados })
  },

  computed: {
    ...mapGetters('ctrlModulos', ['listaDeModulos', 'loadingModulo', 'paginacao']),

    listagemModulos() {
      if (!this.listaDeModulos) return []
      return this.listaDeModulos.map(modulo => ({
        ...modulo,
        redirecionarUsuarios: `/app/ctrl-modulos/${modulo.id}/usuarios`,
        redirecionarMenus: `/app/ctrl-modulos/${modulo.id}/menus`
      }))
    },

    colunas() {
      return [
        { key: 'selecionar', label: 'Ações', sortable: false },
        { key: 'restaurar', label: 'Restaurar' },
        { key: 'nome', label: 'Nome', sortable: false, width: 200 },
        { key: 'descricao', label: 'Descrição', sortable: false, width: 400 },
        { key: 'icon', label: 'Ícone', sortable: false },
        { key: 'redirecionarUsuarios', label: 'Associar Usuários', sortable: false },
        { key: 'redirecionarMenus', label: 'Gerenciar Menus', sortable: false }
      ]
    }
  },

  methods: {
    ...mapActions('ctrlModulos', [
      'listarModulosAdmin',
      'excluirModulos',
      'restaurarModulo'
    ]),

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra
      }
    },

    gerenciadorDeSelecionados(selecionados) {
      this.modulosSelecionados = selecionados
    },

    adicionarNovoModulo() {
      this.abrirModal = true
      this.tipoFormulario = 'salvar'
      this.modulo = {}
    },

    editarSelecionado() {
      this.tipoFormulario = 'editar'
      this.modulo = this.modulosSelecionados[0]
      this.abrirModal = true
    },

    restaurarModuloSelecionado(modulo) {
      this.restaurarModulo(modulo.id)
      this.exibirItensDeletados = false
      this.listarModulosAdmin(this.montarParametros({ exibirItensDeletados: false }))
    },

    confirmarDelecao() {
      this.excluirModulos(this.modulosSelecionados)
      this.deletarDados = false
    },

    fecharModal() {
      this.abrirModal = false
    },

    async realizarPaginacao(pagina) {
      this.listarModulosAdmin(this.montarParametros({
        page: pagina.current_page,
        current_page: pagina.current_page,
        per_page: pagina.per_page,
        exibirItensDeletados: this.exibirItensDeletados
      }))
    },

    filtrarModulosDeletados(event) {
      this.exibirItensDeletados = event
      this.listarModulosAdmin(this.montarParametros({ exibirItensDeletados: event }))
    }
  }
}
</script>
